import React, { useState } from "react";
import "./signup.css";
import { Link } from "react-router-dom";
import stech from "../../assets/stech.png";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { FaCheck } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { MyContextSupply } from "../../Context";
import axios from "axios";


const Sign_up = () => {
  const {
    toggleRegisterPassword,
    isRegisterPasswordVisible,
    toggleRegisterPasswordTwo,
    isRegisterPasswordVisibleTwo,
  } = MyContextSupply();
  const navigate = useNavigate();
  const [udata, setUdata] = useState({
    fname: "",
    lname: "",
    email: "",
    mobile: "",
    password: "",
    cpassword: "",
  });
  const [isBtnClicked, setIsBtnClicked] = useState(false);
  const [isAdminPinShow, setIsAdminPinShow] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [adminPin, setAdminPin] = useState("");
  const { fname, lname, email, mobile, password, cpassword } = udata;

  const checkCheckBox = (e) => {
    setIsChecked(e.target.checked);
  }
  const settingAdminPin = (e) => {
    setAdminPin(e.target.value);
  }
  const adddata = (e) => {
    const { name, value } = e.target;
    setUdata({ ...udata, [name]: value });
  };

  const toastStyle = {
    position: "top-center",
    autoClose: 2000
  }

  // form data submiting to backend
  const senddata = async (e) => {
    e.preventDefault();

    if (!fname || !lname || !email || !mobile || !password || !cpassword) {
      toast.warn("Please Fill all the inputs", toastStyle);
    } else {
      setIsBtnClicked(true);
      // https://stechbackend-9r4c.onrender.com
      await axios.post("https://stechbackend-9r4c.onrender.com/register", {
        fname,
        lname,
        email,
        mobile,
        password,
        cpassword,
        adminPin
      }).then((res) => {
        if(res.status === 201) {
          toast.success(res.data, toastStyle);
          setUdata({
            ...udata,
            fname: "",
            lname: "",
            email: "",
            mobile: "",
            password: "",
            cpassword: "",
          });
          setAdminPin(null);
          setIsBtnClicked(false);
          navigate("/login");
        }
      }).catch((err) => {
        const status = err.response.status;
        const message = err.response.data.error;
        if (status === 422) {
          toast.warn( message, toastStyle);
        } else if (status === 423) {
          toast.warn(
            message,
            toastStyle
          );
        } else if(status === 404) {
          toast.warn(message, toastStyle);
        } else if (status === 403) {
          toast.warn(message, toastStyle);
        } else {
          toast.warn(message, toastStyle);
        }
        setIsBtnClicked(false);
      })
    }
  };

  return (
    <>
      <div className="section-signin-signup height-signup">
        <div className="sign_container">
          <div className="sign_header">
            <img src={stech} alt="" />
          </div>
          <div className="sign_form">
            <form>
              <h1>Create New Account</h1>
              <div className="form_data">
                <label htmlFor="fname">First Name</label>
                <input
                  type="text"
                  name="fname"
                  id="fname"
                  onChange={adddata}
                  value={fname}
                  className="input-register-signin"
                />
              </div>
              <div className="form_data">
                <label htmlFor="lname">Last Name</label>
                <input
                  type="text"
                  name="lname"
                  id="lname"
                  onChange={adddata}
                  value={lname}
                  className="input-register-signin"
                />
              </div>
              <div className="form_data">
                <label htmlFor="">Email</label>
                <input
                  type="text"
                  name="email"
                  id="email"
                  onChange={adddata}
                  value={email}
                  className="input-register-signin"
                />
              </div>
              <div className="form_data">
                <label htmlFor="mobile">Phone mobile</label>
                <input
                  type="tel"
                  name="mobile"
                  id="mobile"
                  onChange={adddata}
                  value={mobile}
                  className="input-register-signin"
                />
              </div>
              <div className="form_data">
                <label htmlFor="password">Password</label>
                <input
                  type={`${isRegisterPasswordVisible ? "text" : "password"}`}
                  name="password"
                  id="password"
                  onChange={adddata}
                  value={password}
                  placeholder="At least 6 characters"
                  autoComplete="off"
                  className="input-register-signin"
                />
                <p onClick={toggleRegisterPassword} className="posab-eye-icon">
                  {isRegisterPasswordVisible ? (
                    <AiFillEye />
                  ) : (
                    <AiFillEyeInvisible />
                  )}
                </p>
              </div>
              <div className="form_data">
                <label htmlFor="cpassword">Confirm Password</label>
                <input
                  type={`${isRegisterPasswordVisibleTwo ? "text" : "password"}`}
                  name="cpassword"
                  id="cpassword"
                  onChange={adddata}
                  value={cpassword}
                  placeholder="At least 6 characters"
                  autoComplete="off"
                  className="input-register-signin"
                />
                <p
                  onClick={toggleRegisterPasswordTwo}
                  className="posab-eye-icon"
                >
                  {isRegisterPasswordVisibleTwo ? (
                    <AiFillEye />
                  ) : (
                    <AiFillEyeInvisible />
                  )}
                </p>
              </div>
              <div style={{ display: "flex", marginBottom: "10px" }}>
                <input type="checkbox" name="" onChange={checkCheckBox} />
                <label htmlFor="" className="label-checkbox">
                  Register as admin
                </label>
              </div>
              <div className={`form_data admin-pin-given-area ${isChecked && "show-admin-pin-given-area"}`}>
                <input
                  type={`${isAdminPinShow ? "text" : "password"}`}
                  onChange={settingAdminPin}
                  value={adminPin}
                  autoComplete="off"
                  placeholder="admin secret pin"
                  className="input-register-signin"
                />
                <p onClick={() => {
                  setIsAdminPinShow(!isAdminPinShow)
                }} className="posab-eye-icon admin-pin-show-icon">{isAdminPinShow ? (
                    <AiFillEye />
                  ) : (
                    <AiFillEyeInvisible />
                  )}</p>
              </div>
              <button
                onClick={senddata}
                disabled={isBtnClicked}
                className={`${
                  isBtnClicked ? "signin_btn checkedBtn " : "signin_btn"
                }`}
              >
                {isBtnClicked ? <FaCheck className="checkIcon" /> : "Register"}
              </button>
              <div className="signin_info">
                <p>
                  Already have an account?
                </p>
                <Link to="/login" className="regi-signin-navigate-btn">
                    Sign In
                  </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sign_up;
